import { useEffect } from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image } from "react-bootstrap";
import LinkToUsTableSection from "../../../components/common/LinkToUsTableSection/LinkToUsTableSection";
import AdvertisingImage from "../../../assests/images/advertising-image/advertising-image.webp";
import {
    TopBannerSection,
    AdvertisingSection,
    AdvertisingWrap,
    AdvertisingContent,
    AdvertisingImageBox,
    AdvertisingTitle,
    AdvertisingText,
    AdvertisingTextAnchor,
    AdvertisingTextStrong,
    AdvertisingTableSection,
  } from "./AdvertisingStyle";
import {
  ElliottAdvocacyBanner,
    AdvocacyTitle,
} from "../../../components/common/commonSubPageBanner/commonSubPageBannerStyle";
import { useDispatch, useSelector } from "react-redux";
import { advertisingHandler } from "../../../redux/slices/advertising/advertising-slice";
import { MESSAGE } from "../../../utils/message";
import MetaComponent from "../../../components/common/metaComponent";

const Advertising = () => {
const dispatch: any = useDispatch();  
  const advertisingListing : any = useSelector((state:any) => state?.advertising?.data);

  useEffect(()=>{ 
    dispatch(advertisingHandler());
  })
    return (
      <>
      <MetaComponent 
            keywords=""
            description="GreatNonprofits has advertising opportunities. Reach Executive Directors &amp; Staff members of over 20k nonprofits and over 140k volunteers with online marketing."
            ogTitle="Advertising Sponsorships | GreatNonprofits"
            ogDescription="GreatNonprofits has advertising opportunities. Reach Executive Directors &amp; Staff members of over 20k nonprofits and over 140k volunteers with online marketing."
            ogUrl="https://www.about.greatnonprofits.org/advertising"
            ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
        />
      <>
      <TopBannerSection>
        <ElliottAdvocacyBanner className="advertising-banner">
          <Container className="cont-w">
            <AdvocacyTitle className='title-sub-page'>{MESSAGE.advertisingGreatNonprofits}</AdvocacyTitle>
          </Container>
        </ElliottAdvocacyBanner>
      </TopBannerSection>

        <AdvertisingSection>
            <Container className="cont-w">
                <Row>
                    <Col sm="12">
                        <AdvertisingWrap>
                            <AdvertisingContent>
                                <AdvertisingTitle>{MESSAGE.advertisingHeadline}</AdvertisingTitle>
                                <AdvertisingText>{MESSAGE.advertisingMsg1}</AdvertisingText>
                                <AdvertisingText>{MESSAGE.advertisingMsg2}</AdvertisingText>
                                <AdvertisingText><AdvertisingTextAnchor> <Link to="/about/contact-us">Contact us</Link></AdvertisingTextAnchor> for more information.</AdvertisingText>

                                <AdvertisingTitle>{MESSAGE.linkToUs}</AdvertisingTitle>
                                <AdvertisingText>{MESSAGE.linkToUsThankYouMsg}</AdvertisingText>
                                <AdvertisingText>{MESSAGE.linkToUsThankMsg}</AdvertisingText>
                                <AdvertisingText><AdvertisingTextStrong>{MESSAGE.usageGuideline}</AdvertisingTextStrong> Please do not alter the GreatNonprofits logo in any way. If you require the logo in a format or size not provided here, please contact us at <Link to="mailto:support@greatnonprofits.org">support@greatnonprofits.org</Link> and we will be happy to assist you.</AdvertisingText>
                            </AdvertisingContent>

                            <AdvertisingImageBox>
                                <Image src={AdvertisingImage} alt="Advertising Image" />
                            </AdvertisingImageBox>

                        </AdvertisingWrap>
                    </Col>
                </Row>
            </Container>
        </AdvertisingSection>

        <AdvertisingTableSection>
            <LinkToUsTableSection listingData={advertisingListing}/>
        </AdvertisingTableSection>

    </>
      </>
    )
};
export default Advertising;